export default __webpack_public_path__ + "static/media/history_img_5.285702e5.png";